import { z } from 'zod';

const list = z.discriminatedUnion('state', [
  z.object({ state: z.literal('recorded'), rows: z.array(z.string()).min(1) }).strict(),
  z.object({ state: z.literal('not_recorded'), rows: z.array(z.string()).length(0) }).strict(),
]);
export const recordListsViewSchema = z.object({ actions: list, followUps: list }).strict();
export type RecordListsView = z.infer<typeof recordListsViewSchema>;

/** Display shape only: no computation, ranking, or recommendation authoring. */
export function recordListsView(actions: string[], followUps: string[]): RecordListsView {
  const display = (rows: string[]): RecordListsView['actions'] =>
    rows.length ? { state: 'recorded', rows } : { state: 'not_recorded', rows: [] };
  return { actions: display(actions), followUps: display(followUps) };
}
